<app-toast />
<p-confirmDialog />

<section class="refis">
    <div class="refis-inner">
        <app-card-content [border]="false" [title]="'Refis'" [subtitle]="'Cadastro das portarias de REFIS' + (uf() ? ' — ' + uf() : '')" [icon]="'pi pi-percentage'">
            <p-button label="Nova Portaria" icon="pi pi-plus" severity="primary" (click)="abrirNova()" card-header [appCan]="rolePermissaoEditar" />

            <!-- Filtros -->
            <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
                <app-filtro-campo label="UF">
                    <app-estado-select [uf]="filtroUf()" [removeBR]="false" [disabled]="ufTravada()" (ufChange)="filtroUf.set($event)" />
                </app-filtro-campo>
                <app-filtro-campo label="Portaria" [wide]="true" inputId="refis-filtro-portaria">
                    <input id="refis-filtro-portaria" pInputText type="text" class="w-full" [ngModel]="filtroPortaria()" (ngModelChange)="filtroPortaria.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Pesquisar por portaria..." />
                </app-filtro-campo>
            </app-filtros-bar>

            <!-- Barra de status -->
            <div class="flex justify-between items-center gap-3 mb-4">
                <span class="text-sm text-surface-400 dark:text-surface-500">
                    <span class="font-bold text-surface-700 dark:text-surface-200">{{ portariasView().length }}</span>
                    {{ portariasView().length === 1 ? 'portaria' : 'portarias' }}
                </span>
                <app-table-view-switcher [(viewMode)]="currentView" />
            </div>

            @if (currentView() === 'card') {
                <app-card-sort-pills class="mb-4" [opcoes]="sortOpcoes" [(field)]="sortField" [(order)]="sortOrder" (fieldChange)="onSortCardChange()" (orderChange)="onSortCardChange()" />
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    @for (portaria of portariasPagina(); track portaria.id) {
                        <app-card-container>
                            <div class="indicador-topo">
                                <p-badge [value]="portaria.nm_portaria" badgeSize="large" severity="info" />
                                <div class="indicador-contagem">
                                    <div class="indicador-valor">{{ formatarMoeda(portaria.vr_custo) }}</div>
                                    <div class="indicador-label">Custo Operacional</div>
                                </div>
                            </div>

                            <div class="grid grid-cols-2 gap-2 mt-4 text-xs">
                                <div>
                                    <strong>Data Início:</strong><br />
                                    {{ formatarData(portaria.dt_inicio) }}
                                </div>
                                <div>
                                    <strong>Data Fim:</strong><br />
                                    {{ formatarData(portaria.dt_fim) }}
                                </div>
                            </div>

                            <div class="flex justify-end gap-1 mt-4 pt-3 border-t border-surface-200 dark:border-surface-700">
                                <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" (click)="abrirEditar(portaria)" pTooltip="Editar" tooltipPosition="top" [appCan]="rolePermissaoEditar" />
                                <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" size="small" (click)="confirmarExclusao(portaria)" pTooltip="Remover" tooltipPosition="top" [appCan]="rolePermissaoExcluir" />
                            </div>
                        </app-card-container>
                    } @empty {
                        <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                            <i class="pi pi-inbox text-5xl mb-3"></i>
                            <span>Nenhuma portaria cadastrada.</span>
                        </div>
                    }
                </div>
            } @else {
                <p-table [value]="portariasPagina()" [loading]="carregando()" dataKey="id" styleClass="p-datatable-sm refis-table" [customSort]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" (onSort)="onSortChange($event)" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="nm_portaria">
                                <strong>Portaria</strong>
                                <p-sortIcon field="nm_portaria" />
                            </th>
                            <th pSortableColumn="dt_inicio" class="w-40">
                                <strong>Data Início</strong>
                                <p-sortIcon field="dt_inicio" />
                            </th>
                            <th pSortableColumn="dt_fim" class="w-40">
                                <strong>Data Fim</strong>
                                <p-sortIcon field="dt_fim" />
                            </th>
                            <th pSortableColumn="vr_custo" class="w-52 text-right">
                                <strong>Valor Custo Operacional</strong>
                                <p-sortIcon field="vr_custo" />
                            </th>
                            <th class="w-28 text-center"><strong>Ações</strong></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-portaria>
                        <tr>
                            <td>{{ portaria.nm_portaria }}</td>
                            <td>{{ formatarData(portaria.dt_inicio) }}</td>
                            <td>{{ formatarData(portaria.dt_fim) }}</td>
                            <td class="text-right font-medium">{{ formatarMoeda(portaria.vr_custo) }}</td>
                            <td class="text-center">
                                <div class="flex justify-center gap-1">
                                    <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" (click)="abrirEditar(portaria)" pTooltip="Editar" tooltipPosition="top" [appCan]="rolePermissaoEditar" />
                                    <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" size="small" (click)="confirmarExclusao(portaria)" pTooltip="Remover" tooltipPosition="top" [appCan]="rolePermissaoExcluir" />
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5">
                                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                                    <i class="pi pi-inbox text-3xl"></i>
                                    <span class="text-sm">Nenhuma portaria cadastrada.</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }

            <p-paginator (onPageChange)="onPageChange($event)" [first]="first()" [rows]="rows()" [totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 15, 20]" [appendTo]="'body'" />
        </app-card-content>
    </div>
</section>

<!-- ═══ Modal: Cadastro/Edição de Portaria ═══ -->
<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Programa de recuperação fiscal."
    [header]="tituloModal"
    [visible]="modalAberto()"
    (visibleChange)="$event ? null : fecharModal()"
    [style]="{ width: '520px', maxWidth: '96vw' }"
    [closeOnEscape]="true"
>
    <div class="flex flex-col gap-4">
        <div class="field">
            <label class="font-semibold block mb-2">UF</label>
            <app-estado-select [uf]="formUf()" [removeBR]="true" [disabled]="ufTravada()" (ufChange)="formUf.set($event)" />
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="field">
                <label class="font-semibold block mb-2">Portaria</label>
                <input pInputText type="text" class="w-full" [ngModel]="formPortaria()" (ngModelChange)="formPortaria.set($event)" maxlength="20" placeholder="Identificação da portaria" />
                <small class="text-surface-400">Máximo de 20 caracteres.</small>
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Valor Custo Operacional</label>
                <p-inputNumber [ngModel]="formVrCusto()" (ngModelChange)="formVrCusto.set($event)" mode="currency" currency="BRL" locale="pt-BR" [min]="0" class="w-full" inputStyleClass="w-full" />
            </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="field">
                <label class="font-semibold block mb-2">Data Início</label>
                <p-datepicker [ngModel]="formDtInicio()" (ngModelChange)="formDtInicio.set($event)" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
            </div>
            <div class="field">
                <label class="font-semibold block mb-2">Data Fim</label>
                <p-datepicker [ngModel]="formDtFim()" (ngModelChange)="formDtFim.set($event)" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="salvando()" (click)="fecharModal()" />
        <p-button label="Salvar" icon="pi pi-check" severity="primary" [loading]="salvando()" (click)="salvar()" [appCan]="rolePermissaoEditar" />
    </ng-template>
</p-dialog>
